"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "toaster group rounded-lg border border-gray-200 bg-white text-gray-900 shadow-lg",
          title: "font-semibold",
          description: "text-gray-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
